module.exports = __webpack_public_path__ + "img/print.899fe918.gif";